
















import {Vue, Component, Prop} from 'vue-property-decorator';
import ComparisonIndicator from './ComparisonIndicator.vue';

@Component({
    components: {
        ComparisonIndicator
    }
})
export default class SmallDashboardCard extends Vue {
    @Prop({required: true}) title: number;
    @Prop({required: false}) value: number;
    @Prop({required: false}) comparedToAvg: number;
}
